export const SARA_PREFILL_TEXT = 'Sara '

export const isSaraPrefillOnly = (text: string) => text.trim() === 'Sara'
